// Extract the base64-encoded JSON config values from the meta tag.
const appConfigContent = document.querySelector('meta[name="app_config"]').content
const appConfig = JSON.parse(atob(appConfigContent));

export default appConfig;
